import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MatchingParenthesis = ({matchingParenthesis}) => { 
    if (!matchingParenthesis) {
        return [];
    }
    let style = {
        top : matchingParenthesis.y,
        left : matchingParenthesis.x,
    };
    return (
        <div style={style} className="matching-parenthesis"></div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MatchingParenthesis);
